/* eslint-disable max-len */

import React from 'react'

export default ({ className, height = 20, width = 20 }) => (
  <svg
    id={className}
    className={className}
    width={width}
    height={height}
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'>
    <path
      fill='white'
      d='M11.4,10l6.5-6.5c0.2-0.2,0.2-0.5,0-0.7l-0.7-0.7C17,2,16.7,2,16.5,2.2L10,8.6L3.5,2.2C3.4,2,3,2,2.8,2.2L2.2,2.8 C2,3,2,3.4,2.2,3.5L8.6,10l-6.5,6.5C2,16.7,2,17,2.2,17.2l0.7,0.7c0.2,0.2,0.5,0.2,0.7,0l6.5-6.5l6.5,6.5c0.2,0.2,0.5,0.2,0.7,0 l0.7-0.7c0.2-0.2,0.2-0.5,0-0.7L11.4,10z'
    />
  </svg>
)
